import SparkMD5 from 'spark-md5'
import { PDF_PAGE } from '@/client/constant'
/**
 * @description 判断是否是猎豹浏览器
 * @description 猎豹浏览器会存在 window.chrome.LiebaoGetVersion 的全局函数，用于获取浏览器版本
 * @type {*|boolean}
 */
export const isLiebao = window.chrome &&
  window.chrome.LiebaoGetVersion &&
  typeof window.chrome.LiebaoGetVersion === 'function'

/**
 * @description 比较猎豹浏览器版本， 大于返回1，等于返回 0,
 * @param currentVersion{string} // "8.0.0.20879"
 * @param compareVersion{string} // "8.0.0.20889"
 * @return {number}
 */
export const compareLiebaoVersion = function (currentVersion, compareVersion) {
  const currentVersionArray = currentVersion.split('.')
  const compareVersionArray = compareVersion.split('.')
  const length = compareVersionArray.length
  for (let index = 0; index < length; ++index) {
    const currentVersionNum = Number.parseInt(currentVersionArray[index])
    const compareVersionNum = Number.parseInt(compareVersionArray[index])
    if (currentVersionNum > compareVersionNum) {
      return 1
    } else if (currentVersionNum < compareVersionNum) {
      return -1
    }
  }
  return 0
}

/**
 * @description 计算文件的MD5
 * @param file
 * @return {Promise<string>}
 */
export const fileToMD5 = function (file) {
  return new Promise((resolve, reject) => {
    const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
    const chunkSize = 2097152
    const chunks = Math.ceil(file.size / chunkSize)
    let currentChunk = 0
    const spark = new SparkMD5.ArrayBuffer()
    const fileReader = new FileReader()

    fileReader.onload = function (e) {
      spark.append(e.target.result)
      currentChunk++

      if (currentChunk < chunks) {
        loadNext()
      } else {
        resolve(spark.end())
      }
    }

    fileReader.onerror = function (error) {
      reject(error)
    }

    function loadNext () {
      const start = currentChunk * chunkSize
      const end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize

      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
    }

    loadNext()
  })
}

/**
 * @description 获取文件名的后缀
 * @example getFileType(xxxxx.pdf) => pdf
 * @example getFileType(xxxxx.PDF) => pdf
 * @param fileName
 * @return {string}
 */
export const getFileType = function (fileName) {
  return fileName.slice(fileName.lastIndexOf('.') + 1).toLowerCase()
}

/**
 * 从url的hash获取query中的参数
 * @description 有时候query参数会在hash后面,正常方法是获取不了参数,所以只能通过正则去匹配
 * @param {String} name 参数名
 * @returns
 */
export function getQueryStringByHash (name) {
  // eslint-disable-next-line no-useless-escape
  const reg = new RegExp('(^|\&\?)' + name + '=([^&]*)(&|$)', 'i')
  const r = window.location.hash.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

/**
 * 获取打开来源
 * @description 用于上报中的 source 字段
 * @returns
 */
export function getOpenFrom () {
  const href = window.location.href
  const url = new URL(href)
  const params = url.searchParams
  const fromParam = params.get('from') || getQueryStringByHash('from') || 0
  const openFrom = parseInt(fromParam)
  return openFrom
}

/**
 * 根据路由获取当前页
 * @description 用于上报中的 page_show 字段
 * @param {String} router
 */
// eslint-disable-next-line complexity
export function getPageByRouter (router) {
  switch (router) {
    case 'pdfToWord':
      return PDF_PAGE.PDF_2_WORD
    case 'pdfToImage':
      return PDF_PAGE.PDF_2_IMAGE
    case 'pdfToPPT':
      return PDF_PAGE.PDF_2_PPT
    case 'pdfToTxt':
      return PDF_PAGE.PDF_2_TXT
    case 'pdfToExcel':
      return PDF_PAGE.PDF_2_EXCEL
    case 'excelToPdf':
      return PDF_PAGE.EXCEL_2_PDF
    case 'imageToPdf':
      return PDF_PAGE.IMAGE_2_PDF
    case 'PPTToPdf':
      return PDF_PAGE.PPT_2_PDF
    case 'wordToPdf':
      return PDF_PAGE.WORD_2_PDF
    case 'cadToPdf':
      return PDF_PAGE.CAD_2_PDF
    case 'pdfToCad':
      return PDF_PAGE.PDF_2_CAD
    default:
      return PDF_PAGE.HOME
  }
}
